import {
  Component,
  Element,
  Event,
  EventEmitter,
  Listen,
  Prop,
} from '@stencil/core';
import { versionComponent } from '../../../global/inject-dependencies';

@Component({
  tag: 'ui-offcanvas-trigger',
  styleUrl: 'ui-offcanvas-trigger.css',
})
export class UiOffcanvasTrigger {
  @Element() el: HTMLUiOffcanvasTriggerElement;

  @Event() offcanvasTrigger: EventEmitter<{ id: string }>;

  @Prop() offcanvasId: string;

  @Listen('click')
  onClick() {
    this.offcanvasTrigger.emit({ id: this.offcanvasId });
  }
}
versionComponent(UiOffcanvasTrigger);
